import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { Validator } from "../../snippets/Validator";

export class VehicleInvoice extends CRUDEntity {

    #validationFields = [
        'vehicle_id',
        'cost',
        'invoice_date',
        'mechanic',
        'mileage',
        'external_invoice_id'
    ]

    constructor(id=null) {
        Object.assign(VehicleInvoice.prototype, FormActions);
        Object.assign(VehicleInvoice.prototype, EntityModalForm);
        Object.assign(VehicleInvoice.prototype, HasAttachments);

        super();
        this.entityClass = 'vehicle-invoice';
        this.urlRoot = '/vehicles-management/vehicle-invoice';
        this.sectionRootUrl = '/vehicles-management';
        this.id = id;
        this.setAttachmentCallbackDelete();
        this.setAttachmentCallbackPreview();

        VehicleInvoice.prototype.delegatedListnersForButtons = function(type, entityClass) {
            daterangepicker.setPicker($('input#invoices_date-edit'), 'MM/DD/YYYY');

            $(`#${type}-${entityClass} #hints-open`).on('click', (ev)=>{
                let formHTML;
                $.ajax({
                    method: "GET",
                    url: `${this.urlRoot}/get-hints-form`,
                    async: false,
                    success: (response) => {
                        if (response.redirect) window.location = response.redirect;
                        else formHTML = response;
                    }
                });
                const formContainer = $(`#form-container`);
                formContainer.append(formHTML);
                $(`#modal-hints`).modal('show');
            })

            const validateCb = (ev) => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)

                // Save is disabled the moment one field is wrong, so without this the user
                // gets a dead button and no reason. Flag only the field being edited —
                // marking untouched fields red on the first keystroke reads as broken.
                if (ev && ev.target && ev.target.name)
                    this.markField(ev.target);
            }
            for(let field of this.#validationFields){
                $(`#${type}-${entityClass} [name=${field}]`).on('input',validateCb)
            }
            if(type == 'edit')
                validateCb()

            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if(this.validationForm(type,true)){
                    if (type == 'create')
                        this.create(()=>setTimeout(() => window.location.reload(), 500));
                    if (type == 'edit')
                        this.update(()=>setTimeout(() => window.location.reload(), 500));
                }
            });
        }
    }

    // The field's own placeholder is "0.00", so whole numbers only was wrong — a real
    // price left Save permanently disabled. Invoice numbers likewise carry hyphens and
    // slashes in the wild; the old /^[0-9A-z]+$/ also let through [ \ ] ^ _ ` by accident.
    static rules = {
        'vehicle_id': ['required'],
        'cost': ['required', {regexp: /^[0-9]+(\.[0-9]{1,2})?$/}],
        'invoice_date': ['required'],
        'mechanic': ['required'],
        'mileage': ['required', {regexp: /^[0-9]+$/}],
        'external_invoice_id': ['required', {regexp: /^[A-Za-z0-9][A-Za-z0-9 ._\/#-]*$/}]
    }

    markField(el){
        const valid = new Validator(VehicleInvoice.rules).validate(el.name, el.value);
        $(el).attr('style', valid ? '' : 'border:2px solid var(--bb-danger) !important;');
    }

    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const validator = new Validator(VehicleInvoice.rules);
        let validateFlag = true;
        this.#validationFields.forEach(element => {
            if (validator.validate(element, data[element])) {
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','');
            }else{
                validateFlag = false;
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','border:2px solid var(--bb-danger) !important;');
            }
        });
        return validateFlag;
    }
}
